import React from "react";
import SVG from "react-inlinesvg";
import { Link } from "tsi-common-react/src/components/Link/index";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { jt, t } from "ttag";

import iconSpeechBubblesTalk from "../../../assets/svg/speech-bubbles-talk.svg";

import styles from "../../../styles/composable/basket-summary-help.module.scss";

export const CheckoutSidebarContent = (): React.ReactNode => {
    const phoneHref = usePageSetting("pre_order_phone_number_link") || "";
    const phoneDisplay = usePageSetting("pre_order_phone_number_display") || "";
    const returnPolicyLink = usePageURL("return_policy");
    const shippingDeliveryLink = usePageURL("shipping_and_delivery");
    const returnPolicy = (
        <Link key="returnPolicy" target="_blank" href={returnPolicyLink}>
            {t`return policy?`}
        </Link>
    );
    return (
        <div className={styles.basketSummaryHelp}>
            <h3>
                <SVG
                    className={styles.basketSummaryHelpIcon}
                    src={iconSpeechBubblesTalk}
                />
                {t`Questions?`}
            </h3>
            <div className="basket-summary__text">
                <a className={styles.basketSummaryPhoneLink} href={phoneHref}>
                    {t`Call ${phoneDisplay}`}
                </a>
                <p>{jt`What is your ${returnPolicy}`}</p>
                <p>
                    <Link target="_blank" href={shippingDeliveryLink}>
                        {t`When can I expect my order?`}
                    </Link>
                </p>
            </div>
        </div>
    );
};
